import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RestaurantsTable from '../../components/tables/RestaurantsTable';
import { getRestaurants } from '../../reducers';
import { setRestaurants } from '../../actions/setRestaurants';
import LoadingPage from '../../components/LoadingPage';
import { setActivePropToRestaurant } from '../../actions/SetActivePropToRestaurant';
import Search from 'antd/lib/input/Search';

function compareNames( a, b ) {
    if ( a.name > b.name ) {
      return 1;
    }
    if ( a.name < b.name ) {
      return -1;
    }
    return 0;
};

class RestaurantsAdmin extends Component {
    state = {
        data: null
    }

    handleRestaurants() {
        const { restaurants, setRestaurants } = this.props;
        if(!restaurants) {
            setRestaurants();
            return <LoadingPage className="LoadingPageCont"/>;
        }
    }

    handleActiveRestaurant = (record) => {
        const { setActivePropToRestaurant } = this.props;
        setActivePropToRestaurant({ id: record.id, active: !record.active });
    }

    renderData = (name) => {
        const { restaurants } = this.props;
        if(restaurants) {
            const data = [];
            var restaurantsData = [];
            for (var key in restaurants) {
                if(name === "" || (restaurants[key] && restaurants[key].name && restaurants[key].name.toLowerCase().indexOf(name.toLowerCase()) !== -1)) {
                    restaurantsData.push(restaurants[key]);
                }
            }
            restaurantsData.sort(compareNames);
            restaurantsData.forEach(restaurant => {
                    data.push({
                        id: restaurant.id,
                        name: restaurant.name, 
                        active: restaurant.active,
                        email: restaurant.email,
                        isLoading: restaurant.isLoading,
                    });
            });
            this.setState({ data: data })
        }
    }

    render() {
        const { restaurants } = this.props;
        return (
            <div>
                {
                    restaurants ?
                        <div>
                            <Search style={{ marginBottom: '20px'}} placeholder="Nombre del restaurante" onSearch={(value) => this.renderData(value)} enterButton />
                            {
                                this.state.data === null && this.renderData("")
                            }
                            <RestaurantsTable data={this.state.data} onActiveRestaurant={this.handleActiveRestaurant}/>
                        </div>
                        :
                        this.handleRestaurants()
                }
            </div>
        );
    }
}

RestaurantsAdmin.propTypes = {
    restaurants: PropTypes.object,
    setActivePropToRestaurant: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setRestaurants: value => dispatch(setRestaurants(value)),
    setActivePropToRestaurant: value => dispatch(setActivePropToRestaurant(value)),
});

const mapStateToProps = state => ({ 
    restaurants: getRestaurants(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(RestaurantsAdmin));